/* eslint-disable react/jsx-wrap-multilines */
/* eslint-disable react/forbid-prop-types */
import React from 'react';
import PropTypes from 'prop-types';
import { Row, Tab, Tabs } from 'react-bootstrap';
import { StatusCodes } from 'http-status-codes';
import styled from 'styled-components';

import { API_URL, ROLES } from '../../../../utils/constants';
import AutocompleteComponent from '../../../../components/common/forms/Autcomplete/AutocompleteComponent';
import ProductDetails from './ProductDetails';
import ManufacturersApi from '../../../../services/api/ManufacturersApi';
import ProductsApi from '../../../../services/api/ProductsApi';
import ErrorLabel from '../../../../components/common/forms/ErrorLabel';
import ButtonComponent from '../../../../components/common/forms/Button/ButtonComponent';
import RolesDependent from '~/src/components/common/RolesDependent';
import TitleComponent from '~/src/components/common/forms/Title/TitleComponent';
import { Colors } from '~/src/scss/common/style';

interface Props {
  initialProducts: { [key: string]: any }[];
  genericProductId: string;
}

export default function ChoosingManufacturer({ genericProductId, initialProducts }: Props): JSX.Element {
  const [products, setProducts] = React.useState(null);
  const [manufacturers, setManufacturers] = React.useState(null);
  const [tabKey, setTabKey] = React.useState('');

  const setFieldValue = async (e, v) => {
    // Save to DB
    const ids = v.map((item) => item.id);
    const res = await ProductsApi.createRemoveProducts(genericProductId, ids);
    if (res.status === StatusCodes.OK) {
      setProducts(res.data);
      setTabKey(v.id);
    }
  };

  const initManufacturers = async () => {
    const res = await ManufacturersApi.getList();
    if (res.status === StatusCodes.OK) {
      setManufacturers(res.data.data);
    }
  };

  React.useEffect(() => {
    setProducts(initialProducts);
    if (initialProducts && initialProducts.length > 0 && initialProducts[0].manufacturer) {
      setTabKey(initialProducts[0].manufacturer.id + 0);
    }
    initManufacturers();
  }, []);

  const SwapManufacturer = async (manufacturerId) => {
    // Save to DB
    const res = await ProductsApi.swapManufacturer(genericProductId, manufacturerId);
    if (res.status === StatusCodes.OK) {
      setProducts(res.data);
      const correctProduct = res.data.find((x) => x.manufacturer.id === manufacturerId);
      if (correctProduct) {
        setTabKey(correctProduct.manufacturer.id);
        setTimeout(() => {}, 1000);
      }
    }
  };

  const handleManufacturerDelete = async (e, id) => {
    e.preventDefault();
    e.stopPropagation();
    const res = await ProductsApi.delete(id);
    const newProduct = products.filter((x) => x.id !== id);
    setProducts(newProduct);
  };

  const handleManufacturerSelect = async (e, v) => {
    if (v !== '') {
      const res = await ProductsApi.create(genericProductId, v);
      if (res.status === StatusCodes.OK) {
        setProducts(res.data);
        setTabKey(v);
      }
    }
  };

  const mergeProducts = async (id) => {
    const remains = products.filter((x) => x.id != id).map((x) => x.id);
    const dto = {
      productToRemain: id,
      productsToBeMerged: remains,
    };
    const res = await ProductsApi.merge(dto);
    alert(JSON.stringify(res.data));
  };

  return (
    <div>
      <TitleComponent title="Product Passport" />

      {products !== null && manufacturers !== null ? (
        <>
          <Row>
            <BoxWrapper>
              {products != null && products?.length === 1 && products[0].manufacturer?.isTheUnknown === true ? (
                <div className="col-md-6">&nbsp;</div>
              ) : (
                <AutocompleteComponent
                  url={`${API_URL}/contractors/manufacturers/get`}
                  name="manufacturers"
                  onChange={handleManufacturerSelect}
                  getOptionLabel={(option) => `${option.name}`}
                  label="Manufacturer"
                  cols={6}
                />
              )}
              {products.find((x) => x.manufacturer?.isTheUnknown === true) ? (
                <>
                  <AutocompleteComponent
                    url={`${API_URL}/contractors/manufacturers/get`}
                    name="manufacturers"
                    label="Manufacturer"
                    onChange={(e, v) => {
                      SwapManufacturer(v);
                    }}
                    getOptionLabel={(option) => `${option.name}`}
                    label="Swap Unknown Manufacturer to:"
                    cols={12}
                  />
                  <div className="col-md-12">
                    <StyleError>
                      <span style={{ color: '#EF7D00' }}>"Warning:</span> If the new manufacturer you choose
                      exists, the old one will be completely wiped, including all: orders, packages, nutritions,
                      ingredients, suppliers"{' '}
                    </StyleError>
                  </div>
                </>
              ) : null}
            </BoxWrapper>
          </Row>
          <StyledTabs
            activeKey={tabKey}
            onSelect={(k) => {
              setTabKey(k);
            }}
          >
            {products.map((sph, i) => {
              return (
                <StyledTab
                  eventKey={sph.manufacturer.id + i}
                  title={<>{sph.manufacturer.name} </>}
                  key={sph.manufacturer.name + Math.random(10000)}
                >
                  <ProductDetails product={sph} mergeFunc={mergeProducts} />
                </StyledTab>
              );
            })}
          </StyledTabs>
        </>
      ) : null}
    </div>
  );
}

const StyleError = styled.p`
  text-align: left;
  display: flex;
  width: 100%;
  margin-top: 17px;
  color: ${Colors.darkBrown};
  font-size: 13px;
  font-weight: 700;
  text-align: center;
`;

const StyledTabs = styled(Tabs)`
  .nav-link {
    color: #929292;
    font-size: 15px;
    font-weight: 700;
    background: #e7e7e7;
    margin-right: 5px;
    div {
      display: flex;
    }
  }
  .nav-link.active {
    display: flex;
    color: ${Colors.darkBrown};
    font-size: 15px;
    font-weight: 700;
    background: #f4f4f4;
    border: 1px solid #f4f4f4;
  }
`;

const StyledTab = styled(Tab)`
  color: #fff;
  font-size: 15px;
  font-weight: 700;
  background: #e7e7e7;
`;

const BoxWrapper = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: column;
  width: 100%;
  margin-bottom: 25px;
  padding: 21px;
  width: 100%;
  background: rgba(239, 125, 0, 0.09);
  border: 2px solid ${Colors.newOrage};
  border-radius: 10px;
  height: 100%;
`;
